/*
 * Lokal persistens för importfliken (per användare, localStorage):
 *  - övningsalias: csvName → exerciseTypeId (flyttas till servern i steg 2)
 *  - senaste importer (visas på startvyn)
 */
function key(name, username) { return `gymtracker.import.${name}:${username || '_anon'}`; }

function read(name, username, fallback) {
  try {
    const raw = localStorage.getItem(key(name, username));
    return raw ? JSON.parse(raw) : fallback;
  } catch { return fallback; }
}
function write(name, username, value) {
  try { localStorage.setItem(key(name, username), JSON.stringify(value)); } catch { /* privat läge etc. */ }
}

export function loadAliases(username) { return read('aliases', username, {}); }
export function saveAliases(username, aliases) { write('aliases', username, aliases); }
export function rememberAliases(username, mappings) {
  const aliases = loadAliases(username);
  for (const m of mappings) {
    if (m.action === 'map' && m.exerciseTypeId) aliases[m.csvName] = m.exerciseTypeId;
    if (m.action === 'create' && m.exerciseTypeId) aliases[m.csvName] = m.exerciseTypeId;
  }
  saveAliases(username, aliases);
  return aliases;
}

export function loadRecentImports(username) { return read('recent', username, []); }
export function pushRecentImport(username, entry) {
  const list = [entry, ...loadRecentImports(username)].slice(0, 8);
  write('recent', username, list);
  return list;
}
export function clearRecentImports(username) { write('recent', username, []); }
